import request from '../_helpers/request';

export const newsService = {
    LoadNewsRecords,
    LoadNewsRecordsList,
    SaveNewsRecords,
    SubmitNewsRecords,
    DeleteNewsRecords,
    GetNewsEBoothAData,
    ApproveNewsRecords
};

function LoadNewsRecords(query) {
    return request({
        url: 'News/LoadNewsRecords',
        method: 'post',
        params: query
    });
}
function LoadNewsRecordsList(query) {
    return request({
        url: 'News/LoadNewsList',
        method: 'post',
        params: query
    });
}
function SaveNewsRecords(query) {
    return request.post('News/SaveNewsRecords', query)
        .then(res => {
            return res;
        });
}
function SubmitNewsRecords(query) {
    return request({
        url: 'News/SubmitNewsRecords',
        method: 'post',
        params: query
    });
}
function DeleteNewsRecords(query) {
    return request({
        url: 'News/DeleteNewsRecords',
        method: 'post',
        params: query
    });
}
function GetNewsEBoothAData(query) {
    return request({
        url: 'News/GetNewsEBoothAData',
        method: 'post',
        params: query
    });
}
function ApproveNewsRecords(query) {
    return request.post('News/ApproveNewsRecords', query)
        .then(res => {
            return res;
        });
}